import React from "react";
import { useRouteError } from "react-router-dom";

const RootError = () => {
  const error = useRouteError();

  return (
    <div className="h-screen w-full flex justify-center items-center">
      <div className="flex items-center gap-3">
        <h2 className="text-2xl">{error.status}</h2>
        <div className="h-10 w-[1px] bg-white"></div>
        <p className="text-sm">This page could not be found</p>
      </div>
    </div>
  );
};

export default RootError;
